import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import ArrowChange from '../ArrowChange';

const RatingCountry = ({ country, metric }) => (
  <div className={cx('rating-country', { 'd-flex': country.percentage_of === 0 })}>
    <p className="country-name">
      {country.country_iso === 'other' ? 'Other' : COUNTRIES_ARRAY[country.country_iso]}
    </p>
    <div className="country-info">
      <div className="rating-line-gray">
        <div
          className="rating-line"
          style={{ width: `calc((100% * ${country.percentage_of}) / 100)` }}
        />
      </div>
      <p className="country-percentage">{country.percentage_of}%</p>
      {country.value_change !== 0 && country[metric] !== 0 &&
        <ArrowChange
          change={country.value_change || country[metric]}
          upArrowClass=""
          downArrowClass=""
          showMathOperators
          precision={3}
          iconPosition="behind"
          className="country-change"
          showBrackets
        />}
    </div>
  </div>
);

RatingCountry.propTypes = {
  country: T.object.isRequired,
  metric: T.string,
};

export default RatingCountry;
